import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React from 'react';
import { ThingsToDoShelfState } from '../../../../types/ThingsToDoShelf';

import './ThingsToDoShelfContainer.scss';

const ThingsToDoShelf = loadable(
    () => import('../../../../components/ThingsToDoShelf'),
    {
        resolveComponent: (component: { ThingsToDoShelf: React.ReactNode }) =>
            component.ThingsToDoShelf,
    },
);

export const ThingsToDoShelfContainer: React.FunctionComponent<
    ThingsToDoShelfState
> = ({ tags, header, locale, usesLanguageSubdirectory }) => {
    const localePath = usesLanguageSubdirectory && locale ? `/${locale}` : '';
    const shelfHeader = {
        title: gettext('Things to do around %(geo)s', {
            geo: header.placeName,
        }),
        url: `${localePath}${header.url}`,
    };

    const shelfTags = tags.map((tag) => ({
        displayText: gettext('Things to do in %(geo)s', {
            geo: tag.placeName,
        }),
        linkUrl: `${tag.linkUrl.split('/ttd/')[0]}${localePath}/ttd/${
            tag.linkUrl.split('/ttd/')[1]
        }`,
    }));

    const showThingsToDoShelf = shelfTags.length > 0;

    return (
        <>
            {showThingsToDoShelf && (
                <ThingsToDoShelf
                    tags={shelfTags}
                    header={shelfHeader}
                    shelfClassName="city-browse-ttd-shelf"
                    tagsConfig={{
                        backgroundColor: 'white',
                        tagColor: '#F8F7FA',
                    }}
                    shelfBackgroundColor="white"
                />
            )}
        </>
    );
};
